import { render } from "./CategorySelectionPage.vue?vue&type=template&id=58388e0c&scoped=true"
import script from "./CategorySelectionPage.vue?vue&type=script&lang=js"
export * from "./CategorySelectionPage.vue?vue&type=script&lang=js"

import "./CategorySelectionPage.vue?vue&type=style&index=0&id=58388e0c&lang=css"
import "./CategorySelectionPage.vue?vue&type=style&index=1&id=58388e0c&scoped=true&lang=css"

import exportComponent from "D:\\a\\1\\s\\ProtectionGuruVue\\client-app\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-58388e0c"]])

export default __exports__